import { ChevronLeft, Plus } from 'lucide-react';
import { BACK_BTN, PRIMARY_BTN } from 'components/Profile/Insurance/helper';

const Intro = ({ onAdd, onCancel = null }) => (
  <div className={`relative flex flex-col items-center rounded-2xl border border-gray-200 bg-white px-6 pb-10 text-center ${onCancel ? 'pt-14' : 'pt-10'}`}>
    {onCancel && (
      <button type="button" onClick={onCancel} aria-label="Back" className={`${BACK_BTN} absolute left-4 top-4`}>
        <ChevronLeft size={16} strokeWidth={2.5} />
      </button>
    )}

    <p className="text-base font-bold text-secondary-900">Nothing on file yet</p>
    <p className="mt-1 max-w-sm text-sm text-secondary-500">
      Tell us about any allergies, conditions or medications so we're prepared for your visit. Takes about a minute.
    </p>

    <button type="button" onClick={onAdd} className={`${PRIMARY_BTN} mt-5`}>
      <Plus size={15} strokeWidth={2.5} />
      Add medical history
    </button>
  </div>
);

export default Intro;
